import React from "react";

// Mui Styles
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import DataTable from "@/components/dataTable";

//MUi icon
import IconButton from "@mui/material/IconButton";
import Edit from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";

//import generate csv library
import { CSVLink } from "react-csv";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Fetch
import {
  getStockOnHandTypeManageById,
  getStockOnHandManageById,
  getStockAdjustRequestReason,
} from "@/fetch/fetchStock";

// Config
import { StockOnHandTypeByIdTableColumn } from "@/config/tableColumnConfig";
import StockOnHandEditDialog from "@/components/Dialog/stockOnHandEditDialog";
import { useCurrentAction } from "@/hooks/user";

const StockOnHandTypeManageByIdPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Navigate
  const navigate = useNavigate();

  //react-router-dom param
  const { id, itemId } = useParams();

  // create a headers for generate csv file
  const headers = [
    { label: "貨品名稱", key: "item_name" },
    { label: "Opening Balance", key: "opening_balance" },
    { label: "調整數量", key: "qty" },
    { label: "Ending Balance", key: "ending_balance" },
    { label: "建立時間", key: "created" },
    { label: "類別", key: "types" },
    { label: "原因", key: "reason" },
    { label: "備註", key: "remark" },
  ];

  // States
  const [itemData, setItemData] = React.useState([]);
  const [stockDialog, setStockDialog] = React.useState({
    open: false,
    id,
    itemId,
    itemName: "",
    onHandQty: 0,
    selectReason: [],
  });
  const [fullname, setFullname] = React.useState("");
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      const dataType = await getStockOnHandTypeManageById(id, itemId);
      if (dataType && dataType.results) {
        setItemData(dataType.data.movement);
      }

      const data = await getStockOnHandManageById(id);
      if (data && data.results) {
        setFullname(data.data[0].full_name);
        const targetObject = data.data.find(
          (item) => item.giveaway_master_item_id === parseInt(itemId)
        );
        setStockDialog((prev) => ({
          ...prev,
          onHandQty: targetObject.stockonhand_qty,
          itemName: targetObject.item_name,
        }));
      }

      const dataReason = await getStockAdjustRequestReason("adjust");
      if (dataReason && dataReason.results)
        setStockDialog((prev) => ({
          ...prev,
          selectReason: [...dataReason.data],
        }));
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  const onClose = () => {
    setStockDialog((prev) => ({ ...prev, open: !prev.open }));
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManagePage"
      selectedIndex={21}
      open={open}
      setOpen={setOpen}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
    >
      <Title
        history={() => navigate(-1)}
        title={`倉存管理 / ${fullname} / ${
          itemData[0]?.item_name ? itemData[0]?.item_name : ""
        }`}
        children={
          <div>
            {/* Edit Record */}
            {actions?.update && (
              <IconButton
                component="label"
                onClick={() =>
                  setStockDialog((prev) => ({ ...prev, open: !prev.open }))
                }
              >
                <Edit />
              </IconButton>
            )}
            {actions?.download && (
              <CSVLink
                data={itemData}
                filename={`Stock on Hand List - ${moment(Date.startDate).format(
                  "YYYY-MM-DD"
                )} to ${moment(Date.endDate).format("YYYY-MM-DD")} `}
                headers={headers}
              >
                <IconButton component="label">
                  <DownloadIcon />
                </IconButton>
              </CSVLink>
            )}
          </div>
        }
      />
      <StyledPaper page={"yes"}>
        <StockOnHandEditDialog
          {...{
            ...stockDialog,
            onClose,
            fetchAll,
            setSnackMessage,
            setSnackOpen,
            setSnackSeverity,
          }}
        />
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={itemData}
            columns={StockOnHandTypeByIdTableColumn}
            onRowClick={({ row }) => {
              switch (row.types) {
                case "return":
                  navigate(`/returnInvoice/${row.type_id}`);
                  break;
                case "exchangeFrom":
                case "exchangeTo":
                  navigate(`/exchangeInvoice/${row.type_id}`);
                  break;
                case "transferFrom":
                case "transferTo":
                  navigate(`/transferInvoice/${row.type_id}`);
                  break;
                case "refill":
                  navigate(`/deliveryOrder/${row.type_id}`);
                  break;
                case "giveaway":
                  navigate(`/cutomerDaily?id=${row.type_id}`);
                  break;
                default:
                  break;
              }
            }}
            checkboxSelection={false}
            initialState={{
              sorting: {
                sortModel: [{ field: "created", sort: "desc" }],
              },
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default StockOnHandTypeManageByIdPage;
